import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material"
import Grid from "@mui/material/Grid2"
import { useNavigate } from "react-router-dom"
import type { ReportPage } from "../constants/reportPages"
import {
  eventReports,
  organizationReports,
  userReports,
} from "../constants/reportPages"

type ReportSection = {
  title: string
  reports: ReportPage[]
}

const reportSections: ReportSection[] = [
  {
    title: "Organization",
    reports: organizationReports,
  },
  {
    title: "Events",
    reports: eventReports,
  },
  {
    title: "User Reports",
    reports: userReports,
  },
]

function HomePage() {
  const navigate = useNavigate()

  return (
    <Stack spacing={4}>
      <Typography variant="h1">MobileMind Data Portal</Typography>

      {reportSections.map((section) => (
        <Stack key={section.title} spacing={2}>
          <Typography variant="subtitle1">{section.title}</Typography>
          <Grid container spacing={3} alignItems="stretch">
            {section.reports.map((report) => (
              <Grid
                size={{ xs: 12, md: 4 }}
                key={report.path}
                sx={{ display: "flex" }}
              >
                <Card elevation={2} sx={{ width: "100%", display: "flex" }}>
                  <CardActionArea
                    onClick={() => navigate(report.path)}
                    sx={{ p: 3, display: "flex", width: "100%" }}
                  >
                    <CardContent
                      sx={{ textAlign: "center", width: "100%", my: "auto" }}
                    >
                      <Box sx={{ mb: 2 }}>
                        <report.icon
                          sx={{ fontSize: 60, color: "primary.main" }}
                        />
                      </Box>
                      <Typography variant="h5" component="h3" gutterBottom>
                        {report.title}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {report.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </Stack>
  )
}

export default HomePage
